import React from 'react'
import styles from './ColorOption.module.css'


const ColorOption = ( { value, name, htmlFor, handleChange, id, selectedColor, type, disabled, handleSelection } ) => {

    const checkColor =(color)=> {
        switch(color) {
            case "black": 
            return styles.black
    
            case "brown":
            return styles.brown
    
            case "red":
            return styles.red
    
            case "gray":
            return styles.gray

            case "blue":
            return styles.blue

            case "white":
            return styles.white

            case "purple":
            return styles.purple

            case "cyan":
            return styles.cyan

            case "yellow":
            return styles.yellow
            
            case "green":
            return styles.green
    
            default:
                return null
    
        }
    }


    return (
            <div className={styles.selectContainer}>
                <label htmlFor={htmlFor} className={styles.container}>
                <input 
                    type={type} 
                    name={name} 
                    value={value}
                    id={id}
                    onChange={handleChange || handleSelection}
                    disabled={disabled}
                    
                />
                <span className={`${styles.checkmark} ${checkColor(selectedColor)}`} />
            </label >
            </div>
    )
}

export default ColorOption
